import { render, staticRenderFns } from "./jobdetail.vue?vue&type=template&id=51104664&scoped=true"
import script from "./jobdetail.vue?vue&type=script&lang=js"
export * from "./jobdetail.vue?vue&type=script&lang=js"
import style0 from "./jobdetail.vue?vue&type=style&index=0&id=51104664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51104664",
  null
  
)

export default component.exports